import React from "react";
import { Word } from "./components/newWord";
import { SentenceSC, SentenceWrapperSC, WordBankContainerSC } from "./styled";
import { IWord } from "../EditBox/types";
import { Button } from "antd";
import { TranslatedVariant } from "../../index";

interface WordBankProps {
  recommendations: TranslatedVariant[];
  onWordClick: (word: IWord) => void;
  addWords: (words: IWord[]) => void;
}

export const WordBank: React.FC<WordBankProps> = ({ recommendations, onWordClick, addWords }) => {
  return (
    <WordBankContainerSC>
      {recommendations.map((sentence, index) => {
        return (
          <SentenceSC key={index}>
            <SentenceWrapperSC>
              {sentence.translated_sentence.map((word, j) => (
                <Word key={word.id} word={word} onClick={onWordClick} />
              ))}
              <Button
                type={"primary"}
                onClick={() => addWords(sentence.translated_sentence)}
                size={"small"}
              >
                take all
              </Button>
            </SentenceWrapperSC>
          </SentenceSC>
        );
      })}
    </WordBankContainerSC>
  );
};
